// @flow

import React, { type Node } from 'react';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';

const mapStateToProps = state => ({
  accountId: Account.selectors.all.currentAccountId(state),
  isLoggedIn: Profile.selectors.all.isLoggedIn(state),
  profileId: Profile.selectors.all.currentProfileId(state),
});

type ChildrenProps = {
  accountId: number,
  isLoggedIn: boolean,
  profileId: number,
};

type Props = {
  ...$Exact<ChildrenProps>,
  children: ChildrenProps => Node,
};

const WithCurrentUserInfo = (props: Props) => {
  return <React.Fragment>{props.children(props)}</React.Fragment>;
};

export default connect(mapStateToProps)(WithCurrentUserInfo);
